import React from "react";
import './AcivatePremiumButton.css'

const AcivatePremiumButton=()=>{
    return(
        <button className="active-button-dashboard">
            Acivate Premium
        </button>
    )
}

export default AcivatePremiumButton;